module.exports = __webpack_public_path__ + "assets/e171f6e6a37bb1d943a4331577751a71.png";